<template>
  <div>
    <div class="layout-container grid h-screen w-screen">
      <SidebarProvider>
        <Sidebar />
        <main class="w-full overflow-y-scroll">
          <HeaderToolbar>
            <SidebarTrigger />
            <div class="flex items-center">
              <AdminSearch class="w-full p-4" />
            </div>
          </HeaderToolbar>
          <div class="grid grid-cols-8">
            <div class="col-span-8 flex flex-col">
              <div class="flex-grow p-8">
                <div class="flex items-end justify-between">
                  <div class="flex items-center">
                    <h1 v-if="routeHeader" class="mr-2 text-2xl font-semibold text-gray-900">
                      {{ routeHeader }}
                    </h1>
                    <LoadingSpinner />
                  </div>
                  <div class="flex-grow text-right">
                    <slot name="header"></slot>
                  </div>
                </div>

                <div class="mt-6">
                  <slot v-if="ready"></slot>
                </div>
              </div>
            </div>
          </div>
        </main>
      </SidebarProvider>
    </div>
  </div>
</template>

<script>
import { useTeamStore } from '../../../stores/team.ts';
import Sidebar from './Sidebar/index.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import AdminSearch from '../../admin/AdminSearch.vue';
import { useCurrentUserStore } from '@/stores/currentUser.ts';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import HeaderToolbar from '../HeaderToolbar.vue';

export default {
  name: 'Layout',
  components: {
    Sidebar,
    LoadingSpinner,
    AdminSearch,
    SidebarProvider,
    SidebarTrigger,
    HeaderToolbar,
  },
  props: {
    agentView: {
      default: false,
      required: false,
      type: Boolean,
    },
  },
  setup() {
    const currentUserStore = useCurrentUserStore();
    const teamStore = useTeamStore();
    return { currentUserStore, teamStore };
  },
  data() {
    return {
      sidebar: true,
      ready: false,
    };
  },
  computed: {
    accountDetails() {
      return this.currentUserStore.currentUserAccountDetails;
    },
    routeHeader() {
      let header = '';
      if (this.$route.name.includes('Detail')) {
        header = this.$route.name.replace('Detail', '');
      } else if (this.$route.name.includes('New')) {
        header = this.$route.name.replace('New', '');
      } else if (this.$route.name.includes('Edit')) {
        header = this.$route.name.replace('Edit', '');
      } else if (this.$route.name.includes('Calendar')) {
        header = this.$route.name.replace('Calendar', '');
      } else if (this.$route.name === 'Humaniz University') {
        header = '';
      } else {
        header = this.$route.name;
      }
      return header;
    },
  },
  async mounted() {
    window.document.body.classList.add('lg:overflow-hidden');
  },
  async created() {
    await this.getUserDetails();
    await this.getTeamSetup();
    this.ready = true;
  },
  methods: {
    async getUserDetails() {
      await this.currentUserStore.loadCurrentUserAccountDetails();
      if (this.accountDetails.role === 'Agent' && this.$route.path === '/dashboard') {
        await this.$router.push('/agents/onboarding');
      }

      if (this.accountDetails.role !== 'Agent' && this.accountDetails.isOnboardingCompleted === false) {
        await this.$router.push('/welcome');
      }
    },
    async getTeamSetup() {
      const res = await fetch(`/api/setup/1`);
      const data = await res.json();
      this.teamStore.setTeamSetupProgress(data?.progress ?? 0);
    },
  },
};
</script>

<style>
.layout-container {
  grid-template-rows: 70px calc(100vh - 70px);
}
</style>
